import React ,{useState, useEffect} from 'react'
import { useNavigate } from "react-router-dom";
import { EuiModal, 
EuiModalBody, 
EuiModalFooter, 
EuiButton, 
EuiFlexGroup, 
EuiFlexItem, 
EuiButtonEmpty, 
EuiText,
EuiKeyPadMenu,
EuiKeyPadMenuItem,
EuiIcon } from '@elastic/eui';
import YTModal from './YTModal';
import GetDailyVerse from './DailyVerse';
import {TranslateLanguage} from './KeywordTranslator';
import ChatBotModal from './ChatBotModal';
import ananicon from '../assets/chatbot.svg';
import { ensureMicPermission } from './mic-permission'; // 路径按你的项目调整
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import QTPlayerModal from './QTPlayerModal';
import YearReadModal from './YearReadModal';
import DailyArchivePlayerModal from './DailyArchivePlayerModal';
import { LoginRequiredModal } from './LoginRequiredModal';
import '../style.css';

function DailyWidget(props) {

    var YTKey = 'AIzaSyDEkINWPt1uxNnIXmzng8-HlfwhHDJTJDM'
    var URL365 = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId=UUNBgquLyP2zOAJURDJAUYTA&key=' + YTKey + '&order=date'
    var URLPrayer = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId=UUleOZrc4iverW4h7Ohdv3Cg&key=' + YTKey + '&order=date'

    var currentBrowserLanguage = (navigator.language || navigator.userLanguage) === "zh-CN" ? "S" : "T";
    var qtOption = (localStorage.qtOption) ? localStorage.qtOption : 'CGNTV';
    var yearReadOption =  (localStorage.yearReadOption) ? localStorage.yearReadOption : 'HT';
    let navigate = useNavigate(); 

    const [qtResultLink, setQTResultLink] = useState("");
    const [qtResultText, setQTResultText] = useState("");
    const [dailyVerseLink, setDailyVerseLink] = useState("");
    const [dailyVerseText, setDailyVerseText] = useState("");
    const [divotionLink, setDivotionLink] = useState("");
    const [divotionLinkText, setDivotionText] = useState("");
    const [prayerLink, setPrayerLink] = useState("");
    const [prayerLinkText, setPrayerText] = useState("");  
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [YTVideo, setYTVideo] = useState({
        isActive: false, 
        videoURL: "", 
        videoDescription: "",
        showSelector: false,     // ← 新增：是否顯示來源下拉
        initialSource: "CGNTV",  // ← 新增：進入 QTPlayerModal 的預設來源
    });
    const [isChatBotVisible, setIsChatBotVisible] = useState(false);
    const getOS= () => {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator?.userAgentData?.platform ?? window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;
      
        if (macosPlatforms.indexOf(platform) !== -1) {
          os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
          os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          os = 'Windows';
        } else if (/Android/.test(userAgent)) {
          os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
          os = 'Linux';
        }
        return os;
      }

    const showYTPreview = (videoURL, videoDescription = "", options = {}) => {
        const { showSelector = false, initialSource = "CGNTV", mode = "" } = options;

        setYTVideo({
            isActive: true,
            videoURL,
            videoDescription,
            showSelector,      // ← 帶入旗標
            initialSource,     // ← 帶入來源
            mode,
        });
    };
    // 建議與 showYTPreview 分開，避免影片與讀經混用
    const openYearRead = (initialPlan = "HT") => {
    setYTVideo({
        isActive: true,
        mode: "yearRead",              // ← 新增模式
        videoURL: "",
        videoDescription: "",
        showSelector: false,           // 舊旗標不使用於此
        initialSource: "CGNTV",
        initialPlan,                   // 初始讀經計畫
    });
    };

    const showChatBot = () => setIsChatBotVisible(true);
    const closeChatBot = () => setIsChatBotVisible(false);

    useEffect(()=>{
        loadQT();
        loadDailyVerse();
        load365();
        loadPrayer();
    },[])

// Extract QT Link  
    const loadQT= async () => {
        var results;
        var qtURL;
        var sourceURL;
        var errorMessage = "<p>抱歉，今日的連結出現了點小問題，請再試一次或前往以下該原始頻道觀看。謝謝。</p><p></p>"

        switch(qtOption){
            case "CGNTV":
               qtURL =  'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId=UUqUnxXxHSFb6At-njlSX9AQ&key=' + YTKey + '&order=date';
               //sourceURL = 'https://www.youtube.com/channel/UCtsnsF7IgxvGEUq8VVl_lQQ';
               sourceURL = 'https://www.youtube.com/@CGNChinese_%E6%B4%BB%E6%BD%91%E7%9A%84%E7%94%9F%E5%91%BD';
                setQTResultText(errorMessage + "<a target='_blank' href='" + sourceURL + "'>CGNTV</a>");
                break;
             case "CAI":
                qtURL =  'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId=UUfEbx5pXwoQuj-Y2M6zsDfw&key=' + YTKey + '&order=date';
                sourceURL = 'https://www.youtube.com/user/lalapraise';
                setQTResultText(errorMessage  + "<a target='_blank' href='" + sourceURL + "'>二重行道會 蔡金龍牧師</a>");
                break;
            case "GCH":
                qtURL =  'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId=PLD0gACwZoIrs2s9GeX1Skk5B7L7MHkn3a&key=' + YTKey + '&order=date';
                sourceURL = "https://www.youtube.com/playlist?list=PLD0gACwZoIrs2s9GeX1Skk5B7L7MHkn3a"
                setQTResultText(errorMessage  + "<a target='_blank' href='" + sourceURL + "'>台北榮耀堂 （週一至週五）</a>");
                break;
        }

        await fetch(qtURL)
        .then(function(response){
            return(response.json())
        })
        .then(function(data){
            results = JSON.parse(JSON.stringify(data))
        })

        for(var i = 0; i < results.items.length; i++) {
            var title = results.items[i].snippet.title;
            var matchTitle = title.match(/活潑的生命/gm);
            if(matchTitle != null && matchTitle[0] === "活潑的生命") {
                //var dateString = title.substring(8,16).trim();
                var stringRegX = '\(20\\d{2})[.-]?(\\d{2})[.-]?(\\d{2})'
                var regex = new RegExp( stringRegX , "gm");
                var dateStringPattern = title.match(regex);
                //var dateStringPattern = title.match(/(20\d{2})[.-]?(\d{2})[.-]?(\d{2})/gm);
                var dateString = dateStringPattern != null ?  dateStringPattern[0].replaceAll(".","") : null;

                if(dateString && dateString.slice(-4) === (new Date(Date.now()-(new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10).replace(/[^0-9]/g, "").slice(-4)){
                    setQTResultLink("https://www.youtube.com/watch?v=" + results.items[i].snippet.resourceId.videoId);
                    setQTResultText(title);
                } else {                
                    // try another logic if can't find date
                    var possibleDate = title.replaceAll("活潑的生命","").replaceAll("[","").replaceAll("]","").replaceAll("∣"," ").replaceAll("｜","");
                    var matchDateArray = possibleDate.trim().split(" ");
                    if(matchDateArray[0] && matchDateArray[0].substring(matchDateArray[0].length-4) === (new Date(Date.now()-(new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10).replace(/[^0-9]/g, "").slice(-4)){
                        setQTResultLink("https://www.youtube.com/watch?v=" + results.items[i].snippet.resourceId.videoId);
                        setQTResultText(title);
                    }
                }
            }
        }
        
    }

// Extract Daily verse Link

    const loadDailyVerse = ()=>{
        // var errorMessage = "<p>抱歉，今日的連結出現了點小問題，請再試一次或前往以下該原始頻道觀看。謝謝。</p><p></p>"  // To be refactored with split error and standard description
        var now = new Date();
        var start = new Date(now.getFullYear(), 0, 0);
        var diff = now - start;
        var oneDay = 1000 * 60 * 60 * 24;
        var day = Math.floor(diff / oneDay);

        var dailyVerseSet = GetDailyVerse(day-1, yearReadOption);
        setDailyVerseLink(dailyVerseSet.link);
        setDailyVerseText(dailyVerseSet.book);
    }

// Extract Daily Divotion

    const load365= async () => {
        var results;
        var errorMessage = "<p>抱歉，今日的連結出現了點小問題，請再試一次或前往以下該原始頻道觀看。謝謝。</p><p></p>"
        var sourceURL = "https://www.youtube.com/user/hvfhoc123"
        setDivotionText(errorMessage  + "<a target='_blank' href='" + sourceURL + "'>恩典365</a>"); // To be refactored with split error and standard description

        await fetch(URL365)
        .then(function(response){
            return(response.json())
        })
        .then(function(data){
            results = JSON.parse(JSON.stringify(data))
        })
        for(var i = 0; i < results.items.length; i++) {
            var title = results.items[i].snippet.title;
            if(title.includes("恩典365")) {
                //console.log(title);
                //console.log(title.substring(0,8));
                if(title.substring(0,8) === (new Date(Date.now()-(new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10).replace(/[^0-9]/g, "")){  
                    setDivotionLink("https://www.youtube.com/watch?v=" + results.items[i].snippet.resourceId.videoId);
                    setDivotionText(title);
                }
            }
        }
        
    }

// Extract Daily Prayer

const loadPrayer = async () => {
    var results;
    var errorMessage = "<p>抱歉，今日的連結出現了點小問題，請再試一次或前往以下該原始頻道觀看。謝謝。</p><p></p>"
    var sourceURL = "https://www.youtube.com/channel/UCleOZrc4iverW4h7Ohdv3Cg/videos"
    setPrayerText(errorMessage  + "<a target='_blank' href='" + sourceURL + "'>禱告時光</a>"); // To be refactored with split error and standard description

    await fetch(URLPrayer)
    .then(function(response){
        return(response.json())
    })
    .then(function(data){
        results = JSON.parse(JSON.stringify(data))
    })

    var title = results.items[0].snippet.title;
    setPrayerLink("https://www.youtube.com/watch?v=" + results.items[0].snippet.resourceId.videoId);
    setPrayerText(title);

}  

const handlePlaylistClick = () => {
    // 检查 sessionStorage 中是否存在用户信息
    const user = sessionStorage.getItem('user');

    if (user) {
        // 如果用户已登录，跳转到 playerpage
        navigate('/playerpage');
    } else {
        // 如果用户未登录，跳转到 player 页面
        //navigate('/player');
        setShowLoginModal(true);
    }
};

const handleFavoriteClick = () => {
    // 检查 sessionStorage 中是否存在用户信息
    const user = sessionStorage.getItem('user');

    if (user) {
        // 如果用户已登录，跳转到 favoritepage
        navigate('/favoritepage');
    } else {
        // 如果用户未登录，跳转到 sharepage 页面
        //navigate('/sharepage');
        setShowLoginModal(true);
    }
};

const handleReadingPlansClick = () => {
    const user = sessionStorage.getItem('user');
    if (user) {
        navigate('/reading-plans');
    } else {
        setShowLoginModal(true);
    }
};

const handleRadioClick = () => {
    // 检查 sessionStorage 中是否存在用户信息
    const user = sessionStorage.getItem('user');

    if (user) {
        // 如果用户已登录，跳转到 
        navigate('/radiopage');
    } else {
        // 如果用户未登录，跳转到
        // navigate('/radio');
        setShowLoginModal(true);
    }
};

    // embed-anan.bottom.fix.js
async function openAnan(url = 'https://anan.checkthebible.com/') {
    // 1) 先要到 OS 层麦克风权限（Android）
    const granted = await ensureMicPermission();
    if (!granted) {
        // 这里可选弹个 toast：请在系统中允许麦克风，再重试
        console.warn('未授予麦克风权限，继续打开网页，网页端可能会再次提示');
    }
    // 仅注入一次样式
    if (!document.getElementById('anan-embed-style')) {
        const s = document.createElement('style');
        s.id = 'anan-embed-style';
        s.textContent = `
        :root{
            --anan-bg:#fff; --anan-fg:#111;
            --anan-border:rgba(0,0,0,.06);
            --anan-btn-bg:#dbeafe; --anan-btn-text:#1e3a8a;
        }
        @media (prefers-color-scheme: dark){
            :root{ --anan-bg:#0b0c0e; --anan-fg:#f5f6f7;
                --anan-border:rgba(255,255,255,.08);
                --anan-btn-bg:rgba(59,130,246,.18); --anan-btn-text:#e6edff; }
        }

        /* 覆盖层：全屏容器 */
        #anan-overlay{
            position:fixed; inset:0; z-index:9999;
            display:flex; flex-direction:column;
            background:var(--anan-bg); color:var(--anan-fg);
            overscroll-behavior:contain;
        }

        /* 内嵌页：确保点击穿透正常 */
        #anan-iframe{
            flex:1; min-height:0; width:100%; height:100%;
            border:0; display:block;
            pointer-events:auto;            /* 关键：允许接收点击 */
        }

        /* 底部栏：固定在最底，只有按钮可点 */
        #anan-bar{
            position:fixed; left:0; right:0;
            bottom:0; z-index:10000;        /* 高于 iframe */
            background:var(--anan-bg);
            border-top:1px solid var(--anan-border);
            padding: 8px 12px calc(8px + env(safe-area-inset-bottom));
            display:flex; align-items:center; justify-content:center;
            pointer-events:none;            /* 关键：栏本身不拦截点击 */
        }

        /* 关闭按钮：居中大按钮，接收事件 */
        #anan-close{
            pointer-events:auto;            /* 关键：按钮可点击 */
            appearance:none; border:0; cursor:pointer;
            width:100%; max-width:640px; height:44px;
            background:var(--anan-btn-bg); color:var(--anan-btn-text);
            border-radius:10px;
            font:600 15px/1 system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans", sans-serif;
            -webkit-tap-highlight-color:transparent; touch-action:manipulation;
        }
        #anan-close:hover{ filter:brightness(0.98); }
        #anan-close:active{ transform:translateY(1px); }
        #anan-close:focus-visible{ outline:2px solid rgba(59,130,246,.5); outline-offset:2px; }
        `;
        document.head.appendChild(s);
    }

    // 覆盖层
    let overlay = document.getElementById('anan-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'anan-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');

        overlay.innerHTML = `
        <iframe id="anan-iframe"
            referrerpolicy="strict-origin-when-cross-origin"
            allow="microphone; camera; autoplay; clipboard-write"
            loading="eager"></iframe>

        <div id="anan-bar">
            <button id="anan-close" type="button" aria-label="关闭">关闭</button>
        </div>
        `;
        document.body.appendChild(overlay);

        const close = () => overlay.remove();
        overlay.querySelector('#anan-close').addEventListener('click', close);
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }

    overlay.querySelector('#anan-iframe').src = url;
    }
    window.openAnan = openAnan;

    async function openAnanOrBrowser() {
        if (Capacitor.getPlatform() === 'android') {
            await Browser.open({ url: 'https://anan.checkthebible.com/' });
        } else {
            openAnan(); // iOS 仍用 iframe
        }
    }

    return (
        <>
        {YTVideo.isActive ? (
            <EuiModal
                // className="modal-no-x"
                // style={{ width: 800 }}
                className={[
                    'modal-no-x',
                    'daily-video-modal',
                    'daily-video-modal--compact',
                    (YTVideo.showSelector || YTVideo.mode === "yearRead" || YTVideo.mode === "dailyArchive") && 'daily-video-modal--qt'
                    ].filter(Boolean).join(' ')}
                style={{
                    width: 'min(800px, calc(100vw - 16px))',
                    maxWidth: 'calc(100vw - 16px)'
                }}
                onClose={() => setYTVideo({ isActive:false, videoURL:"", videoDescription:"", showSelector:false, initialSource:"CGNTV" })}
            >
                <EuiModalBody className="daily-video-modal-body">
                    <div className="daily-video-modal-content">
                        {YTVideo.mode === "yearRead" ? (
                            <YearReadModal
                            initialPlan={YTVideo.initialPlan || "HT"}
                            YTKey={YTKey}
                            TranslateLanguage={TranslateLanguage}
                            />
                        ) : YTVideo.mode === "dailyArchive" ? (
                            <DailyArchivePlayerModal
                            source={YTVideo.initialSource}
                            initialURL={YTVideo.videoURL}
                            initialDescription={YTVideo.videoDescription}
                            YTKey={YTKey}
                            TranslateLanguage={TranslateLanguage}
                            />
                        ) : YTVideo.showSelector ? (
                            <QTPlayerModal
                            initialURL={YTVideo.videoURL}
                            initialDescription={YTVideo.videoDescription}
                            initialSource={YTVideo.initialSource}
                            YTKey={YTKey}
                            TranslateLanguage={TranslateLanguage}
                            />
                        ) : (
                            <YTModal
                            videoURL={YTVideo.videoURL}
                            videoDescription={YTVideo.videoDescription}
                            />
                        )}
                    </div>
                </EuiModalBody>

                <EuiModalFooter className="daily-video-modal-footer">
                    <EuiFlexItem grow={false}>
                        <EuiButton
                        color="primary"
                        onClick={() => setYTVideo({ isActive:false, videoURL:"", videoDescription:"", showSelector:false, initialSource:"CGNTV" })}
                        >
                        {TranslateLanguage(localStorage.userLanguage, "關閉")}
                        </EuiButton>
                    </EuiFlexItem>
                </EuiModalFooter>
            </EuiModal>
            ) : null}
        {/* {getOS() !="iOS" && (<EuiFlexGroup alignItems="center" style={{"margin": "0px"}} gutterSize="s">
        <EuiFlexItem></EuiFlexItem>
        <EuiFlexItem><EuiButtonEmpty href="/radio">{TranslateLanguage(localStorage.userLanguage, "詩歌電臺")}</EuiButtonEmpty> </EuiFlexItem>
        <EuiFlexItem></EuiFlexItem>
        </EuiFlexGroup>)
        } */}

        
        {/* <EuiFlexGroup alignItems="center" style={{"margin": "2px"}} gutterSize="s">
            <EuiFlexItem></EuiFlexItem>
            <EuiFlexItem grow={false} style={{"margin": "4px"}} gutterSize="s">
                    <EuiButtonEmpty onClick={()=> showYTPreview(qtResultLink, TranslateLanguage(localStorage.userLanguage,qtResultText))}>{TranslateLanguage(localStorage.userLanguage, "活潑的生命")}</EuiButtonEmpty>
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{"margin": "4px"}} gutterSize="s">
                    <EuiButtonEmpty onClick={()=> showYTPreview(dailyVerseLink)}>{TranslateLanguage(localStorage.userLanguage, "一年讀經")}</EuiButtonEmpty>
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{"margin": "4px"}} gutterSize="s">
                    <EuiButtonEmpty onClick={()=> showYTPreview(divotionLink)}>{TranslateLanguage(localStorage.userLanguage, "恩典365")}</EuiButtonEmpty>
            </EuiFlexItem>           
            <EuiFlexItem grow={false} style={{"margin": "4px"}} gutterSize="s">
                    <EuiButtonEmpty href="/player">{TranslateLanguage(localStorage.userLanguage, "我的歌單")}</EuiButtonEmpty>
            </EuiFlexItem>    
            {getOS() !="iOS" && (<><EuiFlexItem grow={false} style={{"margin": "4px"}} gutterSize="s">
                    <EuiButtonEmpty color="danger" href="/radio">{TranslateLanguage(localStorage.userLanguage, "詩歌電臺")}</EuiButtonEmpty>
            </EuiFlexItem>              
            <EuiFlexItem></EuiFlexItem></>)}  
        </EuiFlexGroup> */}

{/* <EuiFlexGroup justifyContent="spaceAround" style={{margin: '2px', maxHeight: '250px' }} gutterSize="s">
    <EuiFlexItem></EuiFlexItem>

    <EuiFlexItem style={{"margin": "1px"}}>  
        <EuiFlexGroup justifyContent="spaceAround" responsive={false} style={{"margin": "0px"}} gutterSize="s">

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"詩歌電臺")} onClick={handleRadioClick}>
                <EuiIcon type="play" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem
                label={TranslateLanguage(localStorage.userLanguage,"安安AI靈伴")}
                onClick={() => openAnanOrBrowser()}
                >
                <EuiIcon type={ananicon} size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"AI詩歌助手")} onClick={showChatBot}>
                <EuiIcon type={"userAvatar"} size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>
        </EuiFlexGroup>
    </EuiFlexItem>
    <EuiFlexItem style={{"margin": "1px"}}>  
        <EuiFlexGroup justifyContent="spaceAround" responsive={false} style={{"margin": "0px"}} gutterSize="s">
            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"收藏與分享")} onClick={handleFavoriteClick}>
                <EuiIcon type="share" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>     
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage, "我的歌單")} onClick={handlePlaylistClick}>
                <EuiIcon type="list" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>     
            <EuiKeyPadMenuItem 
                label={TranslateLanguage(localStorage.userLanguage, "活潑的生命")} 
                onClick={()=> showYTPreview(
                        qtResultLink,           // 如果希望強制用來源抓，也可傳 ""，由 QTPlayerModal 自動抓
                        qtResultText,           // 你已有的標題文字（可選）
                        { showSelector: true, initialSource: qtOption || "CGNTV" }
                    )}>
                <EuiIcon type="faceHappy" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>
        </EuiFlexGroup>
    </EuiFlexItem>
    <EuiFlexItem style={{"margin": "1px"}}>  
        <EuiFlexGroup justifyContent="spaceAround" responsive={false} style={{"margin": "0px"}} gutterSize="s">
            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
                <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage, "全年讀經")} 
                    // onClick={()=> showYTPreview(dailyVerseLink, null, { showSelector: false })}>
                    onClick={() => openYearRead("HT")} // 預設「時序」（HT）
                > 
                    <EuiIcon type="reporter" size="l" />
                </EuiKeyPadMenuItem>
            </EuiFlexItem> 

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage, "恩典365")} onClick={()=> showYTPreview(divotionLink, null, { showSelector: false })}>
                <EuiIcon type="kqlSelector" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem>

            <EuiFlexItem grow={false} style={{"margin": "0px"}}>
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage, "禱告時光")} onClick={()=> showYTPreview(prayerLink, null, { showSelector: false })}>
                <EuiIcon type="heart" size="l" />
            </EuiKeyPadMenuItem>
            </EuiFlexItem> 
        </EuiFlexGroup>
    </EuiFlexItem>
    <EuiFlexItem></EuiFlexItem>
    </EuiFlexGroup> */}
    <EuiFlexGroup
        className="quick-actions"
        justifyContent="center"
        gutterSize="s"
        wrap                         // ⭐ 允许自动换行
        responsive={false}
        style={{ margin: '2px', maxHeight: '250px' }}
        >
        {/* 每个图标都是一个 tile */}
        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"詩歌電臺")} onClick={handleRadioClick}>
            <EuiIcon type="play" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"AI心靈伴侶")} onClick={openAnanOrBrowser}>
            <EuiIcon type={ananicon} size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"AI詩歌助手")} onClick={showChatBot}>
            <EuiIcon type="userAvatar" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"收藏與分享")} onClick={handleFavoriteClick}>
            <EuiIcon type="share" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"我的歌單")} onClick={handlePlaylistClick}>
            <EuiIcon type="list" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem
            label={TranslateLanguage(localStorage.userLanguage,"活潑的生命")}
            onClick={() => showYTPreview(qtResultLink, qtResultText, { showSelector: true, initialSource: qtOption || "CGNTV" })}
            >
            <EuiIcon type="faceHappy" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"全年讀經")} onClick={() => openYearRead( yearReadOption || "HT" )}>
            <EuiIcon type="reporter" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"讀經計劃")} onClick={handleReadingPlansClick}>
            <EuiIcon type="calendar" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"恩典365")} onClick={() => showYTPreview(divotionLink, divotionLinkText, { mode: "dailyArchive", initialSource: "GRACE365" })}>
            <EuiIcon type="kqlSelector" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>

        <EuiFlexItem grow={false} className="qa-tile">
            <EuiKeyPadMenuItem label={TranslateLanguage(localStorage.userLanguage,"禱告時光")} onClick={() => showYTPreview(prayerLink, prayerLinkText, { mode: "dailyArchive", initialSource: "PRAYER" })}>
            <EuiIcon type="heart" size="l" />
            </EuiKeyPadMenuItem>
        </EuiFlexItem>
        </EuiFlexGroup>
    {/* ChatBotModal component */}
    <ChatBotModal isVisible={isChatBotVisible} closeModal={closeChatBot} />
    <LoginRequiredModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        nextUrl={typeof window !== 'undefined' ? window.location.href : '/'}
        title={TranslateLanguage(localStorage.userLanguage, "請先登入")}
        message={TranslateLanguage(localStorage.userLanguage, "登入後即可使用此功能，若還不是用戶請注冊用戶。")}
    />
    </>
    )

}


export default DailyWidget
